import { request } from '@/utils/request';

//查询列表
export function addFeedback(data: any) {
  return request({
    url: '/cdh/data/feedback/postList',
    method: 'post',
    data,
  });
}
// menuOptions

export function getMenuOptions() {
  return request({
    url: '/cdh/data/feedback/menuOptions',
    method: 'get',
  });
}

export function postFeedbackList(data: any) {
  return request({
    url: '/cdh/data/feedback/list',
    method: 'post',
    data,
  });
}
export function postFeedbackOperations(data: any) {
  return request({
    url: '/cdh/data/feedback/operations',
    method: 'post',
    data,
  });
}

export function getFeedbackDetail(data: any) {
  return request({
    url: '/cdh/data/feedback/details',
    method: 'get',
    params: data,
  });
}

export function getjudgeIcl(data: any) {
  return request({
    url: '/icl/judgeIcl',
    method: 'get',
    params: data,
  });
}
